import { cloneElement } from "react"
import styled from "styled-components"

export default function CenterModal({ id, isBackground = true, children }) {
  return (
    <FullScreen id={id} isBackground={isBackground}>
      {cloneElement(children, { id })}
    </FullScreen>
  )
}

const FullScreen = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: ${({ isBackground }) => (isBackground ? "rgba(0, 0, 0, 0.4)" : "none")};
  z-index: 400;
`
